import { render, staticRenderFns } from "./manageAPI.vue?vue&type=template&id=251ff0c6"
import script from "./manageAPI.vue?vue&type=script&lang=js"
export * from "./manageAPI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports